import type { DefaultTheme } from 'styled-components/macro';

export const getCustomStyles = (
  theme: DefaultTheme
): {
  overlay: { backgroundColor: string };
  spotlight: { borderRadius: string };
} => ({
  overlay: {
    backgroundColor: theme.colors.rgba.variant3,
  },
  spotlight: {
    borderRadius: theme.radius.sm,
  },
});
